class NotifyMeManager {
  constructor() {
    this.triggers = document.querySelectorAll('[data-notifyme-trigger]');
    this.init();
    this.checkForSuccessfulSubmission();
  }

  init() {
    if (this.triggers.length === 0) {
      console.log('No notify me triggers found');
      return;
    }

    console.log('Found ' + this.triggers.length + ' notify me buttons');

    // Add event listeners to all notify me buttons
    this.triggers.forEach(trigger => {
      trigger.removeEventListener('click', this.handleClick);
      trigger.addEventListener('click', this.handleClick);
      console.log('Added click listener to button', trigger);
    });

    // Add event listeners to close buttons
    document.querySelectorAll('[data-notifyme-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', this.handleClose);
    });

    // Add listeners to submit buttons for animation
    document.querySelectorAll('.notifyme-form__submit').forEach(submitBtn => {
      submitBtn.addEventListener('click', this.handleSubmitClick);
    });

    // Close modal when clicking outside
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('notifyme-modal') && event.target.classList.contains('active')) {
        this.handleClose(event);
      }
    });
  }

  handleSubmitClick = (event) => {
    const button = event.currentTarget;
    const form = button.closest('form');
    
    // If form is invalid, don't show the animation
    if (form && !form.checkValidity()) {
      return;
    }
    
    // Save the original button content
    const originalContent = button.innerHTML;
    
    // Show spinner while form submits
    button.innerHTML = '<span class="atc-spinner" aria-hidden="true"></span>';
    
    // Important: We're NOT preventing the form submission or disabling the button
    // This allows the form to submit normally
  }

  checkForSuccessfulSubmission() {
    // Check if there's a form that was successfully submitted
    document.querySelectorAll('.notifyme-modal').forEach(modal => {
      // Look for success message
      const successMessage = modal.querySelector('.notifyme-form__success');
      if (successMessage && getComputedStyle(successMessage).display !== 'none') {
        console.log('Found a successful form submission');
        
        // Make sure modal is visible
        modal.style.display = 'flex';
        modal.classList.add('active');
        
        // Find the submit button and show checkmark
        const submitButton = modal.querySelector('.notifyme-form__submit');
        if (submitButton) {
          submitButton.innerHTML = '<span class="atc-checkmark" aria-hidden="true"></span>';
          submitButton.disabled = true;
        }
        
        // Set a timeout to close the modal after 3 seconds
        setTimeout(() => {
          console.log('Closing modal after successful submission');
          modal.classList.remove('active');
          modal.style.display = 'none';
          document.body.style.overflow = '';
        }, 3000);
      }
    });
  }

  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    const button = event.currentTarget;
    console.log('Notify me button clicked', button);
    
    // Get product ID from data attribute
    const productId = button.getAttribute('data-product-id');
    if (!productId) {
      console.error('No product ID found on button');
      return;
    }
    
    console.log('Opening modal for product ID:', productId);
    
    const modal = document.getElementById(`NotifyMeModal-${productId}`);
    if (!modal) {
      console.error('Modal not found for product ID:', productId);
      return;
    }
    
    // Display the modal
    modal.style.display = 'flex';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    console.log('Modal opened', modal);
  }

  handleClose = (event) => {
    event.preventDefault();
    
    const modal = event.target.closest('.notifyme-modal');
    if (modal) {
      modal.classList.remove('active');
      modal.style.display = 'none';
      document.body.style.overflow = '';
      console.log('Modal closed', modal);
    }
  }
}

// Initialize when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  window.notifyMeManager = new NotifyMeManager();
});

// Re-initialize when content changes
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    window.notifyMeManager = new NotifyMeManager();
  });
}

// Initialize immediately if the DOM is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  window.notifyMeManager = new NotifyMeManager();
}

// Check if the page was just loaded after a successful form submission
window.addEventListener('load', () => {
  if (window.notifyMeManager) {
    window.notifyMeManager.checkForSuccessfulSubmission();
  }
});
